import React from "react";

const Error = () => {
  return <div>Invalid url</div>;
};

export default Error;
